import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Grid,
    Input,
    Select,
    Text,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import { redirect } from "react-router-dom";
import axios from "axios";

type props = {
    setIsCreateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleRefreshAllData: () => void;
    initialData?: any;
};

export default function CreateAd({
    setIsCreateModalOpen,
    handleRefreshAllData,
    initialData
}: props): JSX.Element {
    console.log("initial data", initialData)
    const [formData, setFormData] = useState<any>({
        name: "",
        redirect_url: "",
        image: "",
        is_active: false,
    });

    const [errors, setErrors] = useState<Record<string, string>>({});
    const { toastNotify } = useContext(AppContext);

    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setFormData({
                name: initialData.name,
                redirect_url: initialData.redirect_url,
                // image: initialData.path,
                is_active: initialData.is_active
            });
        }
    }, []);

    const ValidateForm = async (): Promise<boolean> => {
        const newErrors: Record<string, string> = {};

        // Validate required fields
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.redirect_url) newErrors.redirect_url = "Redirecting URL is required";
        if (!formData.image) newErrors.image = "Image is required";
        if (formData.is_active === "") newErrors.is_active = "Is active is required";

        // Check image aspect ratio
        if (formData.image) {
            const imageFile = formData.image as File;  // Assuming the formData.image contains a File object
            const isValidAspectRatio = await validateImageAspectRatio(imageFile);
            if (!isValidAspectRatio) {
                newErrors.image = "Image aspect ratio should be 16:9";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateImageAspectRatio = (file: File): Promise<boolean> => {
        const img = new Image();
        return new Promise<boolean>((resolve) => {
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                resolve(Math.abs(aspectRatio - 16 / 9) < 0.01); // 16:9 aspect ratio
            };
            img.src = URL.createObjectURL(file);
        });
    };

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        if (name === "is_active") {
            setFormData((prev: any) => ({
                ...prev,
                [name]: value === "true", // Convert to boolean
            }));
            return;
        }

        setFormData((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const isValidRatio = await validateImageAspectRatio(file);
            if (!isValidRatio) {
                setErrors((prev) => ({
                    ...prev,
                    image: "Image must have an aspect ratio of 16:9.",
                }));
            } else {
                setErrors((prev) => {
                    const { image, ...rest } = prev;
                    return rest; // Remove image error if valid
                });
                setFormData((prev: any) => ({
                    ...prev,
                    image: file,
                }));
            }
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!ValidateForm()) return;

        const formDataPayload = new FormData();
        formDataPayload.append("name", formData.name);
        formDataPayload.append("redirect_url", formData.redirect_url);
        formDataPayload.append("is_active", formData.is_active.toString());
        formDataPayload.append("file", formData.image);

        formDataPayload.forEach((value, key) => {
            console.log(`${key}: ${value}`);
        });
        try {
            // const response: any = await appRequest("ads", "uploadAd", formDataPayload);
            const token = localStorage.getItem('auth-token');
            const headers = {
                'Authorization': `Bearer ${token}`,
            };

            const response: any = await axios.post('https://demo-products.sequelstring.com/dmrd-buyer-dashboard/ads/uploadAd', formDataPayload, {
                headers: headers,
            });

            console.log('Response:', response.data);

            if (response.data.status === "success") {
                toastNotify({
                    title: "Success",
                    message: "Ad added successfully",
                    type: "success",
                });
                setIsCreateModalOpen(false);
                handleRefreshAllData();
            } else {
                toastNotify({
                    title: "Error in adding Ad",
                    message: response.data.message,
                    type: "error",
                });
            }
        } catch (error: any) {
            console.error("Error in adding Ad", error.message);
        }
    };

    return (
        <>
            <Box mt={4}>
                <form onSubmit={handleSubmit}>
                    <Grid
                        gap={6}
                        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                        mb={8}
                        p={5}
                        shadow={"base"}
                        rounded={"lg"}
                        borderWidth={1}
                    >
                        <FormControl variant={"floating"} isInvalid={!!errors.name}>
                            <Input
                                id="name"
                                name="name"
                                placeholder=""
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            <FormLabel htmlFor="name">Name</FormLabel>
                            <FormErrorMessage>{errors.name}</FormErrorMessage>
                        </FormControl>
                        <FormControl variant={"floating"} isInvalid={!!errors.redirect_url}>
                            <Input
                                id="redirect_url"
                                name="redirect_url"
                                placeholder=""
                                value={formData.redirect_url || ""}
                                onChange={handleInputChange}
                            />
                            <FormLabel htmlFor="redirect_url">Redirecting URL</FormLabel>
                            <FormErrorMessage>{errors.redirect_url}</FormErrorMessage>
                        </FormControl>
                        <FormControl variant={"floating"} isInvalid={!!errors.image}>
                            <Input
                                type="file"
                                id="image"
                                name="image"
                                accept="image/*"
                                // value={formData.image}
                                onChange={handleFileChange}
                            />
                            <FormLabel htmlFor="image">Image</FormLabel>
                            <Text fontSize="sm" color="gray.500" mt={2}>
                                Note: Accepted aspect ratio: 16:9
                            </Text>
                            <FormErrorMessage>{errors.image}</FormErrorMessage>
                        </FormControl>
                        <FormControl
                            variant={"floating"}
                            isInvalid={!!errors.is_active}
                        >
                            <Select
                                id="is_active"
                                placeholder=""
                                name="is_active"
                                size={{ base: "sm", md: "md" }}
                                variant="outline"
                                value={formData.is_active.toString()}
                                onChange={handleInputChange}
                            >
                                <option value="">Select</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </Select>
                            <FormLabel htmlFor="is_active">Is Ad active?</FormLabel>
                            <FormErrorMessage>{errors.is_active}</FormErrorMessage>
                        </FormControl>
                    </Grid>
                    <Flex justify={"end"} mt={4}>
                        <Button type="submit" colorScheme="teal">
                            Submit
                        </Button>
                    </Flex>
                </form>
            </Box>
        </>
    );
}
